// Base URL de la API
// Usa la variable de entorno VITE_API_BASE_URL
// Si no está definida, usa URL vacía (proxy de Vite) en dev/preview
// o la URL de Azure en builds de producción para despliegue
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? ''

// Estados de eventos
export const ESTADOS = {
  NUEVO: 1,
  VISTO: 2,
  EN_PROCESO: 3,
  RESUELTO: 4,
  DESCARTADO: 5,
}

export const ESTADOS_LABELS = {
  [ESTADOS.NUEVO]: 'Nuevas',
  [ESTADOS.VISTO]: 'Vistas',
  [ESTADOS.EN_PROCESO]: 'En Proceso',
  [ESTADOS.RESUELTO]: 'Resueltas',
  [ESTADOS.DESCARTADO]: 'Descartadas',
}

export const ESTADOS_COLORS = {
  [ESTADOS.NUEVO]: 'blue',
  [ESTADOS.VISTO]: 'purple',
  [ESTADOS.EN_PROCESO]: 'orange',
  [ESTADOS.RESUELTO]: 'green',
  [ESTADOS.DESCARTADO]: 'gray',
}

// Iconos Heroicons para los estados (nombres de iconos outline)
export const ESTADOS_ICONS = {
  [ESTADOS.NUEVO]: 'BellAlertIcon', // Nuevo, alerta/notificación
  [ESTADOS.VISTO]: 'EyeIcon', // Visto, visualizado
  [ESTADOS.EN_PROCESO]: 'WrenchScrewdriverIcon', // En proceso, trabajo en curso
  [ESTADOS.RESUELTO]: 'CheckCircleIcon', // Resuelto, completado
  [ESTADOS.DESCARTADO]: 'XCircleIcon', // Descartado, cerrado
}

// Severidades
export const SEVERIDADES = {
  BAJA: 1,
  MEDIA: 2,
  ALTA: 3,
}

export const SEVERIDADES_LABELS = {
  [SEVERIDADES.BAJA]: 'Baja',
  [SEVERIDADES.MEDIA]: 'Media',
  [SEVERIDADES.ALTA]: 'Alta',
}

export const SEVERIDADES_COLORS = {
  [SEVERIDADES.BAJA]: 'green',
  [SEVERIDADES.MEDIA]: 'yellow',
  [SEVERIDADES.ALTA]: 'red',
}

// Colores exactos para los puntos de gravedad
export const SEVERIDADES_DOT_COLORS = {
  [SEVERIDADES.BAJA]: '#10B981', // green-500
  [SEVERIDADES.MEDIA]: '#F59E0B', // amber-500
  [SEVERIDADES.ALTA]: '#EF4444', // red-500
}

// Gradientes sutiles para el encabezado según severidad
export const SEVERIDADES_HEADER_GRADIENTS = {
  [SEVERIDADES.BAJA]: 'from-emerald-500/90 to-teal-600/90', // Verde suave
  [SEVERIDADES.MEDIA]: 'from-amber-500/90 to-orange-600/90', // Naranja/amarillo suave
  [SEVERIDADES.ALTA]: 'from-rose-500/90 to-red-600/90', // Rojo suave
}

// Paginación
export const DEFAULT_PAGE_SIZE = 20
export const MAX_PAGE_SIZE = 100

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_STATE: 'savian_radar_auth', // Zustand persist - estado completo
  AUTH_TOKEN: 'savian_radar_token', // Token individual para Axios interceptor
  USER_DATA: 'savian_radar_user',
}
